const React = require('react');
const ReactDOM = require('react-dom');
const { shapes: { ExcelColumn } } = require('react-data-grid');
import FormItemUtil from '../utils/FormItemUtil';

const EditorForDataGridMix = (FormItemEditorForDataGrid) => class extends FormItemEditorForDataGrid {
  
  getStyle(): {width: string}
  {
    return {
      	width: '100%'
    };
  }

  registerStores()
  {
    return;
  }

  handleBlurCommit()
  {
    if(this.justCommit == true)
		{
			this.justCommit = false;return false;
		}
    return true;
  }

  onKeyDownHandler(e)
  {
    if(9===e.keyCode)
    {
      e.preventDefault();
      return true;
    }

    if(13==e.keyCode)
    {
      /*TODO 这段不知道为什么加上了 暂时先去掉let formId = this.props.formId;
      let gridId = this.props.gridXml.id;
      FocusActions.focusSet(formId,gridId,false);*/
      return true;
    }
    //禁用ctrl+A
    if(e.ctrlKey && e.keyCode == 65)
    {
      e.stopPropagation();
      return true;
    }
    super.onKeyDownHandler(e);
  }

  getValue(): any {
    let updated = {};
    updated[this.props.column.key] = this.getInputNode().value;
    return updated;
  }

  getInputNode() {
    let domNode = ReactDOM.findDOMNode(this);
    if (domNode.tagName === 'INPUT') {
      return domNode;
    }

    return domNode.querySelector('input:not([type=hidden])');
  }

  getRowStyles()
  {
    let menuItemId = this.props.menuItemId;
    let formId = this.props.formId;
    let gridId = this.props.gridXml.id;
    return FormItemUtil.getControlStyles(menuItemId,formId,gridId);
  }

  inheritContainerStyles() {
    return true;
  }

  getRelatedTarget(e) 
  {
    if(navigator.userAgent.indexOf("Firefox")>0)
      if(!e.relatedTarget)
        if(e.nativeEvent)
          return e.nativeEvent.explicitOriginalTarget;
    return e.relatedTarget || e.explicitOriginalTarget || document.activeElement; // IE11
  }

  /*FormItemEditorForDataGrid.propTypes = 
  {
	  onKeyDown: React.PropTypes.func.isRequired,
	  value: React.PropTypes.any.isRequired,
	  onBlur: React.PropTypes.func.isRequired,
	  column: React.PropTypes.shape(ExcelColumn).isRequired,
	  commit: React.PropTypes.func.isRequired
  }*/
};
export default EditorForDataGridMix;





// WEBPACK FOOTER //
// ./src/formItem/EditorForDataGridMix.js